import type { DomainGuide } from '@/components/guide/guide-types';

import th from './th.json';
import en from './en.json';
import zh from './zh.json';
import vi from './vi.json';
import km from './km.json';
import lo from './lo.json';
import my from './my.json';

/**
 * Help catalog for the `auth-sessions` domain.
 *
 * `live` — this screen does exactly what it appears to. What it does NOT show
 * is who you are allowed to act on: svc-admin decides that per target
 * (`assertCanManageSessionsFor` + `assertMemberInSubtree`), the gateway gates
 * reads on `admin:read` and revokes on `admin:update`, and the UI only surfaces
 * the refusal as a toast. That rule is the first thing the sheet explains.
 */
export const authSessionsGuide: DomainGuide = {
  // Must match the folder name: the registry's orphan check compares
  // `readdirSync(config/guide)` against the declared domains, and page ids are
  // asserted to carry their own domain as a prefix. Hence `auth-sessions.list`
  // rather than a camelCased id.
  domain: 'auth-sessions',
  pages: [
    {
      id: 'auth-sessions.list',
      route: '/auth-sessions',
      // Reads are admin:read; every revoke is admin:update. Both are checked at
      // the gateway before svc-admin applies its own level/subtree rule.
      permission: 'admin:read',
      status: 'live',
      fields: [
        { key: 'subjectKind', kind: 'status' },
        { key: 'subjectId', kind: 'text' },
        { key: 'issuedAt', kind: 'date' },
        { key: 'ipAddress', kind: 'text' },
        { key: 'userAgent', kind: 'text' },
        { key: 'device', kind: 'text' },
        { key: 'gps', kind: 'text' },
        { key: 'expiresAt', kind: 'date' },
        { key: 'status', kind: 'status' },
      ],
      cautionCount: 6,
      warningCount: 2,
    },
  ],
  copy: { th, en, zh, vi, km, lo, my },
};
